import { BillingPeriodsApi, DocsApi, EquipmentParamOptionsApi, EquipmentParamsApi, EquipmentTypesApi, OrderCommercialsApi, OrderItemsApi, OrdersApi, ServiceLineListOptionsApi, ServiceLineListsApi, ServiceLinesApi, SubscriptionsApi, } from '@wayste/operations-client';
class OperationsService {
    axiosInstance;
    serviceLinesApi;
    serviceLineListsApi;
    serviceLineListOptionsApi;
    equipmentTypesApi;
    equipmentParamsApi;
    equipmentParamOptionsApi;
    subscriptionsApi;
    ordersApi;
    orderCommercialsApi;
    orderItemsApi;
    billingPeriodsApi;
    docsApi;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.serviceLinesApi = new ServiceLinesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLineListsApi = new ServiceLineListsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLineListOptionsApi = new ServiceLineListOptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentTypesApi = new EquipmentTypesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentParamsApi = new EquipmentParamsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentParamOptionsApi = new EquipmentParamOptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.subscriptionsApi = new SubscriptionsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.ordersApi = new OrdersApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderCommercialsApi = new OrderCommercialsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderItemsApi = new OrderItemsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.billingPeriodsApi = new BillingPeriodsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.docsApi = new DocsApi(undefined, undefined, this.axiosInstance.mainInstance);
    }
    adminPortal = {
        serviceLines: {
            list: async (options) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.serviceLinesApi.operationsV1ServiceLinesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.serviceLinesApi.operationsV1ServiceLinesIdDelete(params);
            },
            lists: {
                create: async (params) => {
                    const response = await this.serviceLineListsApi.operationsV1ServiceLineListsPost(params);
                    return response.data;
                },
                update: async (params) => {
                    const response = await this.serviceLineListsApi.operationsV1ServiceLineListsIdPut(params);
                    return response.data;
                },
                delete: async (params) => {
                    await this.serviceLineListsApi.operationsV1ServiceLineListsIdDelete(params);
                },
                listOptions: {
                    create: async (params) => {
                        const response = await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsPost(params);
                        return response.data;
                    },
                    update: async (params) => {
                        const response = await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsIdPut(params);
                        return response.data;
                    },
                    delete: async (params) => {
                        await this.serviceLineListOptionsApi.operationsV1ServiceLineListOptionsIdDelete(params);
                    },
                },
            },
        },
        equipmentTypes: {
            list: async (options) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.equipmentTypesApi.operationsV1EquipmentTypesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.equipmentTypesApi.operationsV1EquipmentTypesIdDelete(params);
            },
            params: {
                create: async (params) => {
                    const response = await this.equipmentParamsApi.operationsV1EquipmentParamsPost(params);
                    return response.data;
                },
                update: async (params) => {
                    const response = await this.equipmentParamsApi.operationsV1EquipmentParamsIdPut(params);
                    return response.data;
                },
                delete: async (params) => {
                    await this.equipmentParamsApi.operationsV1EquipmentParamsIdDelete(params);
                },
                options: {
                    list: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsGet(params);
                        return response.data;
                    },
                    create: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsPost(params);
                        return response.data;
                    },
                    update: async (params) => {
                        const response = await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdPut(params);
                        return response.data;
                    },
                    delete: async (params) => {
                        await this.equipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdDelete(params);
                    },
                },
            },
        },
        subscriptions: {
            list: async (options) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsPost(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsIdGet(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.subscriptionsApi.operationsV1SubscriptionsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.subscriptionsApi.operationsV1SubscriptionsIdDelete(params);
            },
        },
        orders: {
            create: async (params) => {
                const response = await this.ordersApi.operationsV1OrdersPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.ordersApi.operationsV1OrdersIdPut(params);
                return response.data;
            },
        },
        orderCommercials: {
            create: async (params) => {
                const response = await this.orderCommercialsApi.operationsV1OrderCommercialsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderCommercialsApi.operationsV1OrderCommercialsIdPut(params);
                return response.data;
            },
        },
        orderItems: {
            create: async (params) => {
                const response = await this.orderItemsApi.operationsV1OrderItemsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderItemsApi.operationsV1OrderItemsIdPut(params);
                return response.data;
            },
        },
        billingPeriods: {
            list: async (options) => {
                const response = await this.billingPeriodsApi.operationsV1BillingPeriodsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.billingPeriodsApi.operationsV1BillingPeriodsIdGet(params);
                return response.data;
            },
        },
        documents: {
            list: async (options) => {
                const response = await this.docsApi.operationsV1DocsGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.docsApi.operationsV1DocsPost(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.docsApi.operationsV1DocsIdGet(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.docsApi.operationsV1DocsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.docsApi.operationsV1DocsIdDelete(params);
            },
        },
    };
}
export default OperationsService;
//# sourceMappingURL=Operations.service.js.map